import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class FEGeolocation extends MongoEntity {
  static override _class = 'FEGeolocation';
  static override _collectionName = 'smartteams_fe_geolocations';

  @Field(() => String)
  userId: Maybe<string>;

  @Field(() => Float)
  latitude: Maybe<number>;

  @Field(() => Float)
  longitude: Maybe<number>;

  @Field(() => Float)
  accuracy: Maybe<number>;

  @Field(() => String)
  updatedAt: Maybe<string>;

  /** True when the FE has actively started tracking; gates whether customers/admins can see the live position. */
  @Field(() => Boolean, { default: v => v ?? false })
  isTracking: Maybe<boolean>;
}
